
//const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

const cbip = {InputLabelProps:{ shrink:true,}};
    

export const reportconfig = {
  
  activityreport: {
    service: {
      name: 'activity',
      title: 'Activity Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}}
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'}
  },

  compliancereport: {
    service:{
      name:'compliance',
      title:'Compliance Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:1,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:1,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
        { id:'evi',label:'Event',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'event'}},
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'},
  },

  customerreport: {
    service:{
      name:'customer',
      title:'Customer Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:1,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:1,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
        { id:'cti',label:'Type',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'customertype'}}
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'},
  },

  eventreport: {
    service:{
      name:'event',
      title:'Events Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:1,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:1,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'}
  },

  notificationreport: {
    service:{
      name:'notification',
      title:'Notification Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:0,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:0,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
        { id:'nti',label:'Type',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'notificationtype'}},
        { id:'nsi',label:'State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'notificationstate'}}
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'}
  },

  performancereport: {
    service:{
      name:'performance',
      title:'Performance Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:0,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:0,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'}
  },

  requestreport: {
    service:{
      name:'request',
      title:'Request Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:0,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:0,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
        { id:'rti',label:'Type',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'requesttype'}},
        { id:'rsi',label:'State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'requeststate'}}
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'}
  },

  reviewreport: {
    service:{
      name:'review',
      title:'Review Report',
      key: 'rid',
      num: true,
      fields:['rid','nam','shc','dsc','ati','atn','atc','eni','enm','enc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',ati:'Type',eni:'Entity',sts:'Status'},
      grid: [],
		  bar: {pag:true,btn:['print']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        { id:'rpt',label:'Report Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'reporttype'}},
        { id:'sdt',label:'Start Date',type:'df',req:1,ops:{ placeholder:'Select Start Date'} },
        { id:'edt',label:'Stop Date',type:'df',req:1,ops:{ placeholder:'Select Stop Date'} },
        { id:'eni',label:'Entity',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'entity'}},
        { id:'rti',label:'Type',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'reviewtype'}},
        { id:'rsi',label:'State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'reviewstate'}}
      ],
    },
    create:true,
    actions: {print:'Download'},
    panels: {print:'custom'}
  },

};
